import React from 'react';
import { Send, Truck } from 'lucide-react';
import { useLeadForm } from '../LeadFormContext';
export function PromoBanner() {
  const {
    openForm
  } = useLeadForm();
  return <section className="bg-[#E67E22] px-5 py-14 md:px-12 lg:px-24" data-id="element-133">
      <div className="max-w-2xl mx-auto text-center" data-id="element-134">
        <Truck className="w-10 h-10 text-white/90 mx-auto mb-4" data-id="element-135" />
        <h2 className="font-heading font-bold text-[26px] md:text-[36px] text-white leading-tight mb-3" data-id="element-136">
          Предзаказ = бесплатная доставка до&nbsp;вашего хозяйства
        </h2>
        <p className="text-base md:text-lg text-white/85 mb-8" data-id="element-137">
          Оформите предзаказ на любой трактор Kubota — доставим прямо до места
        </p>

        <button onClick={openForm} className="inline-flex items-center justify-center gap-2.5 w-full md:w-auto bg-[#0A1A3F] hover:bg-[#0d2255] text-white font-heading font-bold text-lg min-h-[56px] px-8 rounded-2xl transition-colors cursor-pointer" data-id="element-138">
          <Send className="w-5 h-5" data-id="element-139" />
          Оформить предзаказ
        </button>
      </div>
    </section>;
}